{
    "formControls": {
        "formRows": [
            {
                "formGroups": [
                {
                    "style": {
                        "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "containerNo",
                        "displayLabel": "Container No",
                        "disabled": true,
                        "placeHolder": "Enter Container No",
                        "fieldInfo": {
                            "dataType": "text"
                        }
                    }
                },
                {
                    "style": {
                        "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "shippingLineId",
                        "displayLabel": "Shipping Line",
                        "disabled": false,
                        "placeHolder": "Select Shipping Line",
                        "fieldInfo": {
                            "dataType": "picklist",
                            "lookupDetails": {
                                "apiUrl": "v1/customers/list",
                                "filterByKeys": ["NAME_CONTAINS"],
                                "limit": 10,
                                "orderBy": { "name": "asc" },
                                "bindLabel": "name",
                                "bindValue": "id",
                                "additionalFilters": [
                                    {
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    },
                                    {
                                        "name": "CUSTOMER_TYPE_CONTAINS",
                                        "alias": "customerType",
                                        "operator": "IN",
                                        "value": ["LINE"]
                                    }
                                ],
                                "displayColumns": [
                                    { "key": "code", "header": "Code" },
                                    { "key": "name", "header": "Name" }
                                ]
                            }
                        },
                        "validators": [
                            {
                                "type": "autocompleteRequired",
                                "message": "Shipping Line is required"
                            }
                        ]
                    }
                }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "isoCode",
                            "displayLabel": "ISO Code",
                            "placeHolder": "Enter Container Size",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/size-type/alias/list",
                                    "selectFields": ["id", "alias", "sizeTypeId.size AS size", "sizeTypeId.type AS type"],
                                    "filterByKeys": ["alias"],
                                    "limit": 10,
                                    "orderBy": { "alias": "asc" },
                                    "bindLabel": "alias",
                                    "bindValue": "alias",
                                    "displayColumns": [
                                        { "key": "alias", "header": "Alias" },
                                        { "key": "size", "header": "Size" },
                                        { "key": "type", "header": "Type" }
                                    ]
                                }
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "containerSize",
                            "displayLabel": "Size",
                            "placeHolder": "Enter Container Size",
                            "isReadOnly": true,
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "containerType",
                            "displayLabel": "Type",
                            "placeHolder": "Enter Container Type",
                            "isReadOnly": true,
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups": [
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "vesselId",
                            "displayLabel": "Vessel",
                            "disabled": false,
                            "placeHolder": "Select Vessel",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
                                    "filterByKeys": ["VESSEL_NAME_CONTAINS", "VIA_NO_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "vesselName",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "IS_ACTIVE",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "vesselName", "header": "Vessel Name" },
                                        { "key": "viaNo", "header": "Via No" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Vessel is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "accountHolderId",
                            "displayLabel": "Primary Customer",
                            "disabled": false,
                            "placeHolder": "Select Primary Customer",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/customers/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "code", "header": "Code" },
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Primary Customer is required"
                                }
                            ]
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "secondaryCustomerId",
                            "displayLabel": "Secondary Customer",
                            "disabled": false,
                            "placeHolder": "Select Secondary Customer",
                            "fieldInfo": {
                                "dataType": "picklist",
                                "lookupDetails": {
                                    "apiUrl": "v1/customers/list",
                                    "filterByKeys": ["NAME_CONTAINS"],
                                    "limit": 10,
                                    "orderBy": { "name": "asc" },
                                    "bindLabel": "name",
                                    "bindValue": "id",
                                    "additionalFilters": [{
                                        "name": "IS_ACTIVE",
                                        "alias": "active",
                                        "operator": "EQ",
                                        "value": ["true"]
                                    }],
                                    "displayColumns": [
                                        { "key": "code", "header": "Code" },
                                        { "key": "name", "header": "Name" }
                                    ]
                                }
                            },
                            "validators": [
                                {
                                    "type": "autocompleteRequired",
                                    "message": "Primary Customer is required"
                                }
                            ]
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "tareWeight",
                            "displayLabel": "Tare Weight",
                            "placeHolder": "Enter Tare Weight",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "totalPackages",
                            "displayLabel": "NOP",
                            "placeHolder": "Enter NOP",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    },{
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "cargoWeight",
                            "displayLabel": "Cargo Weight",
                            "placeHolder": "Enter Cargo Weight",
                            "fieldInfo": {
                                "dataType": "number"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "reeferPluggedIn",
                            "skipLabel": true,
                            "displayLabel": "Reefr Plugged In",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "odc",
                            "skipLabel": true,
                            "displayLabel": "ODC",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "dpd",
                            "skipLabel": true,
                            "displayLabel": "DPD",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    }
                ]
            },

            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "hazardous",
                            "skipLabel": true,
                            "displayLabel": "Hazardous",
                            "fieldInfo": {
                                "dataType": "boolean"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "imdgClass",
                            "displayLabel": "IMDG Class",
                            "placeHolder": "Enter IMDG Class",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "conditions": {
                                "disabled": {
                                    "logic": "AND",
                                    "rules": [
                                    { "field": "hazardous", "operator": "EQUALS", "value": false }
                                    ]
                                }
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "unNo",
                            "displayLabel": "UN No",
                            "placeHolder": "Enter UN No",
                            "fieldInfo": {
                                "dataType": "text"
                            },
                            "conditions": {
                                "disabled": {
                                    "logic": "AND",
                                    "rules": [
                                    { "field": "hazardous", "operator": "EQUALS", "value": false }
                                    ]
                                }
                            }
                        }
                    }
                ]
            },
            {
                "formGroups":[
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "lineSealNo",
                            "displayLabel": "Line Seal No",
                            "placeHolder": "Enter Seal No",
                            "fieldInfo": {
                                "dataType": "text"
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "scanType",
                            "displayLabel": "Scan Type",
                            "placeHolder": "Enter Scan Type",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "importType",
                            "displayLabel": "Import Type",
                            "placeHolder": "Select Import Type",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    }
                ]
            },

            {
                "formGroups": [
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "deliveryMode",
                            "displayLabel": "Delivery Mode",
                            "placeHolder": "Select Delivery Mode",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    },
                    {
                        "style": {
                            "gridColumn": "span 3"
                        },
                        "control": {
                            "label": "condition",
                            "displayLabel": "Condition",
                            "placeHolder": "Select Condition",
                            "fieldInfo": {
                                "dataType": "select",
                                "options": []
                            }
                        }
                    }
                ]
            }
        ]
    },


"filterConfig": {
  "filterFields": [
    {
      "name": "CONTAINER_NO_EQUALS",
      "displayLabel": "Container No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "CONTAINER_NO_EQUALS"
      }
    },
    {
      "name": "IGM_ITEM_NO_EQUALS",
      "displayLabel": "IGM Item No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "IGM_ITEM_NO_EQUALS"
      }
    },
    {
      "name": "BL_NO_EQUALS",
      "displayLabel": "BL No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "BL_NO_EQUALS"
      }
    },
    {
      "name": "ACCOUNT_HOLDER_EQUALS",
      "displayLabel": "Account Holder",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "ACCOUNT_HOLDER_EQUALS"
      },
      "hasLookup": true,
      "searchConfig": {
        "apiUrl": "v1/customers/list",
        "filterByKeys": ["NAME_CONTAINS"],
        "limit": 10,
        "orderBy": { "name": "asc" },
        "bindLabel": "name",
        "bindValue": "id",
        "displayColumns": [{ "key": "name", "header": "Name" }]
      }
    },
    {
      "name": "VESSEL_EQUALS",
      "displayLabel": "Vessel",
      "dataType": "STRING",
      "hasLookup": true,
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "VESSEL_EQUALS"
      },
      "searchConfig": {
        "apiUrl": "v1/vessel-port-train-details/list?useNewContract=true",
        "selectFields": ["id", "vesselName", "viaNo"],
        "filterByKeys": ["VESSEL_NAME_CONTAINS"],
        "limit": 10,
        "orderBy": { "vesselName": "asc" },
        "bindLabel": "vesselName",
        "bindValue": "id",
        "displayColumns": [{ "key": "vesselName", "header": "Vessel Name" }],
        "additionalFilters": {
          "name": "IS_ACTIVE",
          "alias": "IS_ACTIVE",
          "operator": "EQ",
          "value": ["true"]
        }
      }
    }
  ],
  "useNewContract": true
},

"searchBarConfig": {
    "placeHolder": "Search Container Number",
    "filters": [
      {
        "name": "CONTAINER_NO_EQUALS",
        "alias": "container_no"
      }
    ]
  },

    "containerTableConfig": {
        "columns": [
        {
            "fieldName": "containerNo",
            "displayName": "Container No",
            "dataType": "STRING"
        },
        {
          "fieldName": "containerSize",
          "displayName": "Size",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "50px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "40px",
              "border-radius": "6px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center"
            },
            "conditions": [
              {
                "expression": "eq(value, '20')",
                "styleProperties": {
                  "border": "1px solid var(--Blue-200, #B2DDFF)",
                  "background": "var(--Blue-50, #EFF8FF)",
                  "color": "var(--Blue-700, #175CD3)"
                }
              },
              {
                "expression": "eq(value, '40')",
                "styleProperties": {
                  "border": "1px solid var(--Purple-200, #D9D6FE)",
                  "background": "var(--Purple-50, #F4F3FF)",
                  "color": "var(--Purple-700, #5925DC)"
                }
              },
              {
                "expression": "eq(value, '45')",
                "styleProperties": {
                  "border": "1px solid var(--Pink-200, #FCCEEE)",
                  "background": "var(--Pink-50, #FDF2FA)",
                  "color": "var(--Pink-700, #C11574)"
                }
              }
            ]
          }
        },
        {
          "fieldName": "containerType",
          "displayName": "Type",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "50px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "36px",
              "border-radius": "6px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center",
              "background": "var(--Gray-100, #F2F4F7)",
              "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            }
          }
        },
        {
            "fieldName": "vesselName",
            "displayName": "Vessel",
            "dataType": "STRING"
        },
        {
            "fieldName": "viaNo",
            "displayName": "Via No",
            "dataType": "STRING"
        },
        {
            "fieldName": "shippingLineName",
            "displayName": "Shipping Line",
            "dataType": "STRING"
        },
        {
            "fieldName": "gateInDateTime",
            "displayName": "Arrival Date",
            "dataType": "DATETIME"
        },
        {
            "fieldName": "accountHolderName",
            "displayName": "Account Holder",
            "dataType": "STRING"
        },
        {
          "fieldName": "importType",
          "displayName": "Import Type",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "60px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "36px",
              "border-radius": "6px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center",
              "background": "var(--Gray-100, #F2F4F7)",
              "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            }
          }
        },
        {
          "fieldName": "hazardous",
          "displayName": "Hazardous",
          "dataType": "BOOLEAN",
          "thStyleConfig": {
            "width": "80px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "55px",
              "border-radius": "16px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center"
            },
            "conditions": [
              {
                "expression": "eq(value, 'true')",
                "icon": "assets/icons/frame_icon.svg",
                "iconPosition": "left",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px 2px 6px",
                  "align-items": "center",
                  "gap": "4px",
                  "border-radius": "16px",
                  "border": "1px solid var(--Error-200, #FECDCA)",
                  "background": "var(--Error-50, #FEF3F2)",
                  "color": "var(--Error-700, #B42318)"
                },
                "iconStyleProperties": {
                  "width": "16px",
                  "height": "16px",
                  "background": "#D92D20"
                }
              },
              {
                "expression": "eq(value, 'false')",
                "styleProperties": {
                  "width": "40px",
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Gray-200, #E4E7EC)",
                  "background": "var(--Gray-50, #F9FAFB)",
                  "color": "var(--Gray-700, #344054)"
                }
              }
            ]
          }
        },
        {
          "fieldName": "totalPackages",
          "displayName": "NOP",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "50px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "36px",
              "border-radius": "6px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center",
              "background": "var(--Gray-100, #F2F4F7)",
              "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            }
          }
        },
        {
            "fieldName": "cargoWeight",
            "displayName": "Cargo Weight",
            "dataType": "STRING"
        },
        {
          "fieldName": "isReeferPluggedIn",
          "displayName": "Reefer Plugged In",
          "dataType": "BOOLEAN",
          "thStyleConfig": {
            "width": "80px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "40px",
              "border-radius": "16px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center"
            },
            "conditions": [
              {
                "expression": "eq(value, 'true')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Success-200, #ABEFC6)",
                  "background": "var(--Success-50, #ECFDF3)",
                  "color": "var(--Success-700, #067647)"
                }
              },
              {
                "expression": "eq(value, 'false')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Gray-200, #E4E7EC)",
                  "background": "var(--Gray-50, #F9FAFB)",
                  "color": "var(--Gray-700, #344054)"
                }
              }
            ]
          }
        },
        {
          "fieldName": "odc",
          "displayName": "ODC",
          "dataType": "BOOLEAN",
          "thStyleConfig": {
            "width": "80px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "40px",
              "border-radius": "16px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center"
            },
            "conditions": [
              {
                "expression": "eq(value, 'true')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Success-200, #ABEFC6)",
                  "background": "var(--Success-50, #ECFDF3)",
                  "color": "var(--Success-700, #067647)"
                }
              },
              {
                "expression": "eq(value, 'false')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Gray-200, #E4E7EC)",
                  "background": "var(--Gray-50, #F9FAFB)",
                  "color": "var(--Gray-700, #344054)"
                }
              }
            ]
          }
        },
        {
          "fieldName": "dpd",
          "displayName": "DPD",
          "dataType": "BOOLEAN",
          "thStyleConfig": {
            "width": "80px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "40px",
              "border-radius": "16px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center"
            },
            "conditions": [
              {
                "expression": "eq(value, 'true')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Success-200, #ABEFC6)",
                  "background": "var(--Success-50, #ECFDF3)",
                  "color": "var(--Success-700, #067647)"
                }
              },
              {
                "expression": "eq(value, 'false')",
                "styleProperties": {
                  "display": "flex",
                  "padding": "2px 8px",
                  "align-items": "center",
                  "border-radius": "16px",
                  "border": "1px solid var(--Gray-200, #E4E7EC)",
                  "background": "var(--Gray-50, #F9FAFB)",
                  "color": "var(--Gray-700, #344054)"
                }
              }
            ]
          }
        },
        {
            "fieldName": "lineSealNo",
            "displayName": "Line Seal No",
            "dataType": "STRING"
        },
        {
          "fieldName": "deliveryMode",
          "displayName": "Delivery Mode",
          "dataType": "STRING",
          "thStyleConfig": {
            "width": "50px"
          },
          "styleConfig": {
            "type": "badge",
            "styleProperties": {
              "width": "36px",
              "border-radius": "6px",
              "padding": "2px 8px",
              "align-items": "center",
              "display": "flex",
              "font-family": "Inter",
              "font-size": "12px",
              "font-style": "normal",
              "font-weight": "500",
              "line-height": "18px",
              "text-align": "center",
              "background": "var(--Gray-100, #F2F4F7)",
              "box-shadow": " 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            }
          }
        },
        {
            "fieldName": "condition",
            "displayName": "Condition",
            "dataType": "STRING"
        },
        {
            "fieldName": "modifiedBy",
            "dbName": "modified_by",
            "displayName": "Modified By",
            "dataType": "STRING",
            "styleConfig": {
              "type": "user-avatar"
            }
          },
          {
            "fieldName": "modifiedDate",
            "dbName": "modified_date",
            "displayName": "Modified Date",
            "dataType": "DATETIME",
            "sortable": true
          }
    ]
    }
}
